
import { UrlApi } from "../../../../services/apirest";

export const getResumenProductosSucursal = async (sucursalId, desde, hasta) => {
  try {    
    const url = `${UrlApi}/envasado_pedidos/productosxsucursalresumen/${sucursalId}/${desde} 00:00:00/${hasta} 23:59:59`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
    
  } catch (error) {
    console.error('Error en getResumenProductosSucursal:', error);
    throw error;
  }
};

export const getResumenCambiosSucursal = async (sucursalId, desde, hasta) => {
  try {    
    const url = `${UrlApi}/envasado_pedidos_renglon/cambiosresumen/${sucursalId}/${desde} 00:00:00/${hasta} 23:59:59`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
    
  } catch (error) {
    console.error('Error en getResumenCambiosSucursal:', error);
    throw error;
  }
};

export const getResumenPromoSenaSucursal = async (sucursalId, desde, hasta) => {
  try {    
    const url = `${UrlApi}/envasado_pedidos_renglon/promosenaresumen/${sucursalId}/${desde} 00:00:00/${hasta} 23:59:59`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
    
  } catch (error) {
    console.error('Error en getResumenPromoSenaSucursal:', error);
    throw error;
  }
};